import { getAllAxisURL, oneAxisURL } from "../../../services/api";
import {
  LOADING_ONE_AXIS,
  FETCH_ONE_AXIS,
  PATCH_ONE_AXIS,
  FETCH_ONE_AXIS_FAIL,
  PATCH_ONE_AXIS_FAIL,
  POST_AXIS,
  POST_AXIS_FAIL,
  DELETE_AXIS,
  DELETE_AXIS_FAIL,
} from "../actionTypes";

import { SEND_MESSAGE } from "../../message/actions/actionTypes";
import { checkErrorMessage } from "../../../utils/utils";
import api from "../../../services/instanceapi";

export const loadOneAxis = (id) => async (dispatch) => {
  dispatch({
    type: LOADING_ONE_AXIS,
  });
  try {
    const axis = await api.get(oneAxisURL(id));
    const data = axis.data;

    dispatch({
      type: FETCH_ONE_AXIS,
      payload: {
        id: data.id,
        name: data.name,
        comment: data.comment,
        sponsor: data.sponsor,
        stakes: data.stakes,
        swots: data.swots,
        image: data.image,
        isStrategic: data.isStrategic,
      },
    });
    return Promise.resolve();
  } catch (e) {
    const status = e.response.status;
    if (status !== 200) {
      dispatch({
        type: FETCH_ONE_AXIS_FAIL,
      });
      dispatch({
        type: SEND_MESSAGE,
        payload: {
          status: status,
        },
      });
    }
    return Promise.reject(e);
  }
};
export const patchOneAxis = (id, axis_data) => async (dispatch) => {
  try {
    const updatedAxis = await api.patch(oneAxisURL(id), axis_data);
    const data = updatedAxis.data;
    dispatch({
      type: PATCH_ONE_AXIS,
      payload: {
        id: data.id,
        name: data.name,
        comment: data.comment,
        sponsor: data.sponsor,
        stakes: data.stakes,
        swots: data.swots,
        isStrategic: data.isStrategic,
      },
    });
    return Promise.resolve();
  } catch (e) {
    const message = checkErrorMessage(e);
    const status = e.response.status;
    if (status !== 200) {
      dispatch({
        type: PATCH_ONE_AXIS_FAIL,
      });
      dispatch({
        type: SEND_MESSAGE,
        payload: {
          message: message,
        },
      });
    }
    return Promise.reject(e);
  }
};

export const postAxis = (axis_data) => async (dispatch) => {
  try {
    const axis = await api.post(getAllAxisURL(), axis_data);
    dispatch({
      type: POST_AXIS,
      payload: {
        status: axis.status,
      },
    });
    return Promise.resolve();
  } catch (e) {
    const status = e.response.status;
    if (status !== 200) {
      dispatch({
        type: POST_AXIS_FAIL,
        payload: {
          status: status,
        },
      });
    }
    return Promise.reject(e);
  }
};

export const deleteAxis = (id) => async (dispatch) => {
  try {
    const deletedAxis = await api.delete(oneAxisURL(id));
    dispatch({
      type: DELETE_AXIS,
      payload: {
        status: deletedAxis.status,
      },
    });
    return Promise.resolve();
  } catch (e) {
    const status = e.response.status;
    if (status !== 200) {
      dispatch({
        type: DELETE_AXIS_FAIL,
        payload: {
          status: status,
        },
      });
    }
    return Promise.reject(e);
  }
};
